<!-- 公共底部 -->
<template>
  <div class="footer_wrap" v-if="reload">
    <div class="bottom_css">
      <div class="bottom_icon" @click="goHome">
        <img v-if="pageColor() == 1" src="../assets/img/home/容器@2x(3)1.png" alt="">
        <img v-else src="../assets/img/home/容器@2x(3).png" alt="">
        <div class="icon_tit" :class="pageColor() == 1 ?'pick_tit':''">
          首页
        </div>
      </div>
      <div class="bottom_icon" @click="goBasket">
        <img v-if="pageColor() == 2" src="../assets/img/home/容器@2x(4)1.png" alt="">
        <img v-else src="../assets/img/home/容器@2x(4).png" alt="">
        <div class="icon_tit" :class="pageColor() == 2 ?'pick_tit':''">
          试题
        </div>
      </div>
      <div class="bottom_icon" @click="goPersonal">
       
        <img  v-if="pageColor() == 3" src="../assets/img/home/容器@2x(5)1.png" alt="">
        <img  v-else src="../assets/img/home/容器@2x(5).png" alt="">
        <div class="icon_tit" :class="pageColor() == 3 ?'pick_tit':''">
          我的
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(), //当前年份
      color: "",
      color_s: [
        "#FDF993",
        "#607DBF",
        "#E6B6C9",
        "#AADAED",
        "#6B87A1",
        "#C2D0A4",
        "#FF0000",
        "#946029",
        "#C59449",
      ],
      currentPath: "",
      reload: true,
    };
  },
  created() {
    this.currentPath = this.$route.path;
    // console.log(
    //   (this.$route.query.subjectId || this.$route.query.subjectsId) &&
    //     !this.pageColor()
    // );
    if (
      (this.$route.query.subjectId || this.$route.query.subjectsId) &&
      !this.pageColor()
    ) {
      if (this.$route.query.subjectId) {
        this.color =
          "background: " +
          this.color_s[this.$route.query.subjectId - 1] +
          " !important";
      } else {
        this.color =
          "background: " +
          this.color_s[this.$route.query.subjectsId - 1] +
          " !important";
      }

      this.reloads_();
    } else {
      // console.log('as')
      this.color = "background: #F2F2F2 !important";
    }

    // console.log(this.color);
  },
  methods: {
    pageColor() {
      if (
        this.currentPath == "/" 
      ) {
        return 1;
      } else if (
        this.currentPath == "/basketQuestions" 
      ) {
        return 2;
      } else if (
        this.currentPath == "/centerPersonal" 
      ) {
        return 3;
      }else{
        return 0;
      }
    },
    reloads_() {
      this.reload = false;
      this.$nextTick(function () {
        this.reload = true;
      });
    },
    goBasket() {
      if (this.currentPath !== "/basketQuestions") {
        console.log(this.$route.query.subjectsId, "aa");
        this.$router.push({
          name: "BasketQuestions",
          query: {
            subjectsId: this.$route.query.subjectsId
              ? this.$route.query.subjectsId
              : "",
          },
        });
      }
    },
    goPersonal() {
      if (this.currentPath !== "/centerPersonal") {
        this.$router.push({
          name: "CenterPersonal",
        });
      }
    },
    goHome() {
      if (this.currentPath !== "/") {
        this.$router.push({
          name: "home",
        });
      }
    },
    exit() {
      this.$confirm("确定退出?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("tokenChat");
          this.$router.push({
            name: "home",
          });
        })
        .catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          //   });
        });
    },
  },
};
</script>
<style scoped lang='less'>
.footer_wrap {
  // position: absolute;
  background: white;
  position: fixed;
  width: 100%;
  z-index: 1000;
  bottom: 0;
  width: 100%;
  left: 0;
}

.bottom_css {
  display: flex;
  justify-content: space-around;
  width: 100%;
  box-shadow: 0px -2px 10px 0px rgba(51, 51, 51, 0.1);
}

.bottom_icon {
  // height: 70px;
  margin: 15px 0;

  img {
    width: 30px;
  }
}
.icon_tit{
  text-align: center;
  // line-height: 25px;
  margin-top: 5px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 600;
  color: #999999;
}
.pick_tit{
  color: #666666;
}
.bottom_left,
.bottom_right {
  width: calc(50% - 45px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(255, 255, 255);
  padding: 10px 0;
  border: 1px solid #eee;

  img {
    width: 30px;
  }
}

.bottom_left {
  border-end-end-radius: 30px;
  border-start-end-radius: 30px;
  border-left: none;
}

.bottom_right {
  border-end-start-radius: 30px;
  border-start-start-radius: 30px;
  border-right: none;
}

.bottom_con {
  width: 50px;
  height: 50px;
  margin: 0 20px;
  // background: #409eff;
  background: #f2f2f2;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 30px;
  }
}
</style>